(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  const handleIntersection = async (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    const newDocument = new DOMParser().parseFromString(await fetch(url).then((res) => res.text()), 'text/html');

    document.getElementById('product-recommendations').innerHTML =
      newDocument.getElementById('product-recommendations').innerHTML;

    window.history.replaceState({}, '', url.href);
  };

  const productRecommendationsSection = document.querySelector('#product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
})();
